import { createPromiseClient } from "@connectrpc/connect";

import UFunction from "@repo/utils/UFunction";

import { UserService } from "../../gen/kikoff_canada/protobuf/services/user_service_connect";
import Rpc from "../utils/Rpc";

import { canadaServices } from "./services";

const stubs = import.meta.env.DEV
  ? UFunction.memo(() => import("../canada/stubs").then((res) => res.default))
  : undefined;

const serviceCache: Rpc.Cache = {};

export const canadaTransport = Rpc.createTransport({
  serviceCache,
});

serviceCache.UserService = {
  spec: UserService,
  client: createPromiseClient(UserService, canadaTransport),
};

const canadaRpc = Rpc.createServicesClient(canadaServices, {
  serviceCache,
  transport: canadaTransport,
  stubs,
});

export default canadaRpc;
